// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type InboxBellQueryVariables = Types.Exact<{
  internalUser: Types.Scalars['ID']['input'];
  parentTypeNames?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;


export type InboxBellQuery = { __typename?: 'Query', userRelevantCommentStreams: Array<{ __typename?: 'CommentStream', id: string, unreadCount: number }> };


export const InboxBellDocument = gql`
    query InboxBell($internalUser: ID!, $parentTypeNames: [String!]) {
  userRelevantCommentStreams(
    filter: {internalUser: [$internalUser], hasUnreads: true, parentTypeNames: $parentTypeNames}
  ) {
    id
    unreadCount
  }
}
    `;

/**
 * __useInboxBellQuery__
 *
 * To run a query within a React component, call `useInboxBellQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxBellQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxBellQuery({
 *   variables: {
 *      internalUser: // value for 'internalUser'
 *      parentTypeNames: // value for 'parentTypeNames'
 *   },
 * });
 */
export function useInboxBellQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InboxBellQuery, InboxBellQueryVariables> & ({ variables: InboxBellQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InboxBellQuery, InboxBellQueryVariables>(InboxBellDocument, options);
      }
export function useInboxBellLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InboxBellQuery, InboxBellQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InboxBellQuery, InboxBellQueryVariables>(InboxBellDocument, options);
        }
// @ts-ignore
export function useInboxBellSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InboxBellQuery, InboxBellQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InboxBellQuery, InboxBellQueryVariables>;
export function useInboxBellSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InboxBellQuery, InboxBellQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InboxBellQuery | undefined, InboxBellQueryVariables>;
export function useInboxBellSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InboxBellQuery, InboxBellQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InboxBellQuery, InboxBellQueryVariables>(InboxBellDocument, options);
        }
export type InboxBellQueryHookResult = ReturnType<typeof useInboxBellQuery>;
export type InboxBellLazyQueryHookResult = ReturnType<typeof useInboxBellLazyQuery>;
export type InboxBellSuspenseQueryHookResult = ReturnType<typeof useInboxBellSuspenseQuery>;
export type InboxBellQueryResult = ApolloReactCommon.QueryResult<InboxBellQuery, InboxBellQueryVariables>;